/**
 * Посчитать миллисекунды до того когда можно отправить новое сообщение о запросе кода
 * @param time Время формата "2024-12-09T07:03:08.757229760Z"
 * */
export const countTime = (time: string) => new Date(time).getTime() - new Date().getTime();
